import type { TransactionReportItem } from "../../../../graphql/types"

export const FETCH_TRANSACTIONS_REPORT_SUCCESS = "fetchTransactionsReport/success"

export const fetchTransactionsReportSuccess = (transactionsReport: TransactionReportItem[]) => ({
    type: FETCH_TRANSACTIONS_REPORT_SUCCESS,
    payload: {
        transactionsReport: transactionsReport,
    },
})

export const FETCH_TRANSACTIONS_REPORT_FAILURE = "fetchTransactionsReport/failure"

export const fetchTransactionsReportFailure = (error?: any) => ({
    type: FETCH_TRANSACTIONS_REPORT_FAILURE,
    payload: {
        error: error,
    },
})

export const TRANSACTIONS_AGENDA_MOUNTED = "TRANSACTIONS_AGENDA_MOUNTED"

export const transactionsAgendaMounted = () => ({
    type: TRANSACTIONS_AGENDA_MOUNTED,
})

export const CLEAR_TRANSACTIONS_DATA = "CLEAR_TRANSACTIONS_DATA"

export const clearTransactionsData = () => ({
    type: CLEAR_TRANSACTIONS_DATA,
})
